<div class="content">
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 common_title">
          <h2>
            ADD - ANIMAL SAMPLES DETAIL
          </h2>
          <!--<p>Create animal samples detail</p>-->
          <a (click)="backnavigate()" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
            Back
          </a>
        </div>
      </div>
      <br>
      <form class="row" [formGroup]="animal_sample">
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name">Samples Date<span
                style="color: rgb(232, 63, 63);padding-left: 5px;">*</span></label>
            <input type="date" name="SamplesDate" id="SamplesDate" value="" class="form-control"
              [(ngModel)]="sample_date" [ngModelOptions]="{standalone: true}">
            <span class="text-danger" *ngIf="error_flag">Mandatory to fill</span>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name">Samples Collected<span
                style="color: rgb(232, 63, 63);padding-left: 5px;">*</span></label>
            <input type="text" id="Samplescollected" name="Samplescollected" class="form-control"
              [ngModelOptions]="{standalone: true}" [(ngModel)]="sample_collected">
            <span class="text-danger" *ngIf="error_flag">Mandatory to fill</span>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name">Description</label>
            <textarea id="Description" name="Description" class="form-control"></textarea>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 text-center">
          <button type="submit" class="btn btn-fill btn-primary mb-3" (click)="AnimalSamples()">Submit<div
              class="ripple-container"></div></button>
          <button (click)="backnavigate()" class="btn btn-fill btn-default">Cancel<div class="ripple-container"></div>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>